import { render, staticRenderFns } from "./index.vue?vue&type=template&id=64f2e676&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=64f2e676&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f2e676",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64f2e676')) {
      api.createRecord('64f2e676', component.options)
    } else {
      api.reload('64f2e676', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=64f2e676&scoped=true&", function () {
      api.rerender('64f2e676', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/official/components/elogpop/index.vue"
export default component.exports